// frontend/src/services/usersApi.js
import { authenticatedRequest } from './authApi';
import { REST_API_ORIGIN } from '../platform/endpoints';
const API_BASE = REST_API_ORIGIN;

async function req(path, { method = 'GET', token, body } = {}) {
  let res;
  try {
    res = await authenticatedRequest(`${API_BASE}${path}`, {
      rawResponse: true,
      method,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
      credentials: 'include',
      diagSource: 'usersApi',
    });
  } catch (e) {
    const err = new Error('Network error');
    err.cause = e;
    err.status = 0;
    throw err;
  }

  let data = null;
  try { data = await res.json(); } catch {}
  if (!res.ok) {
    const msg = (data && (data.message || data.error)) || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.payload = data;
    throw err;
  }
  return data ?? null;
}

/**
 * Busca usuarios por nombre o email.
 * El backend debe exponer: GET /api/users/search?q=texto
 * y devolver un array de usuarios con campos: _id, fullName, email, photoPath, zodiacSign
 * y opcionalmente flags isFriend / isPending.
 */
export async function searchUsers(token, q) {
  const qs = new URLSearchParams({ q: q || '' }).toString();
  return req(`/api/users/search?${qs}`, { token });
}
